import { render } from "./ProjectPage.vue?vue&type=template&id=67e201c1"
import script from "./ProjectPage.vue?vue&type=script&lang=js"
export * from "./ProjectPage.vue?vue&type=script&lang=js"

import "./ProjectPage.vue?vue&type=style&index=0&id=67e201c1&lang=css"
script.render = render

export default script